module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_05-9675fa0e54cfd26088f37eb07d83a0e7.jpg";